import React from "react"
import { graphql, useStaticQuery, Link } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


import './footer.css'


export default function Footer(lang) {





  const data = useStaticQuery(graphql`
     {
        wpcontent {
            themeFooterSettings {
              footer {
                socialIcons {
                  fieldGroupName
                  icon {
                    altText
                    sourceUrl
                  }
                  link {
                    target
                    title
                    url
                  }
                }
                copyright
                anschrift
              }
            }
            menusde: menus(where: {language: "de", location: FOOTER_MENU}) {
              nodes {
                id
                name
                menuItems {
                  edges {
                    node {
                      label
                      path
                      id
                    }
                  }
                }
              }
            }
            menusen: menus(where: {language: "en", location: FOOTER_MENU}) {
              nodes {
                id
                name
                menuItems {
                  edges {
                    node {
                      label
                      path
                      id
                    }
                  }
                }
              }
            }
          }
      }
    `);
  
 
  const copyright = data.wpcontent.themeFooterSettings.footer?.copyright + ' ' + new Date().getFullYear();


  return (
    <div className="footer">
      <footer className="container-fluid footer-container">
        <Row>
          <Col xs={12} md={9}>
            <div dangerouslySetInnerHTML={{ __html: data.wpcontent.themeFooterSettings.footer?.anschrift }} />
          </Col>
          <Col className="right-align-flex" xs={12} md={3}>
            {data.wpcontent.themeFooterSettings.footer.socialIcons.map(item => (
              <a key={item.link?.url} href={item.link?.url} target={item.link?.target}>
                <img className="socialIcon" src={item.icon?.sourceUrl} alt={item.icon?.alt} />
              </a>
            ))}
          </Col>
        </Row>
        <Row className="bottom-row">
          <Col xs={12} md={5}>
            <ul>
              {lang.lang == 'de' ?
                <>
                  {data.wpcontent.menusde.nodes[0].menuItems.edges.map(item => (
                    <li key={item.node.label}>
                      <Link to={item.node.path} dangerouslySetInnerHTML={{ __html: item.node?.label }} />
                    </li>
                  ))}
                </>
                :
                <>
                  {data.wpcontent.menusen.nodes[0].menuItems.edges.map(item => (
                    <li key={item.node.label}>
                      <Link to={item.node.path} dangerouslySetInnerHTML={{ __html: item.node?.label }} />
                    </li>
                  ))}
                </>
              }
            </ul>
          </Col>
          <Col xs={12} md={7}><p className="copyright" dangerouslySetInnerHTML={{ __html: copyright }} /></Col>
        </Row>
      </footer>

    </div>
  )
}


